import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>&copy; {new Date().getFullYear()} My Trading App. All rights reserved.</p>
    </footer>
  );
}

export default Footer;